import React from "react";
import { useHistory } from "react-router";
import "./Logo.scss";

function Logo() {
  let history = useHistory();
  return (
    <div className="ideal-logo">
      <img
        onClick={() => history.push("/")}
        src="/Images/Logo/ideal_logo.svg"
      />
    </div>
  );
}

export default Logo;
